export default {
    when() {
        return document.querySelectorAll('.is-title-wrapped').length > 0;
    },

    mounted() {
        let allTitles = document.querySelectorAll('.is-title-wrapped');
        // To know if the title element is wrapped (and hide dash if so)
        // See section-dash-text
        let previousTitle = null;
        let count = 0;
        allTitles.forEach((title, i) => {
            if (i > 0) {
                title.previousElementSibling.classList.remove('hidden');
                if (title.offsetTop !== previousTitle.offsetTop) {
                    title.previousElementSibling.classList.add('hidden');
                    if (count > 0) {
                        allTitles[i - 1].nextElementSibling.classList.remove('bg-black');
                        allTitles[i - 1].nextElementSibling.classList.add('bg-transparent');
                    } 
                        
                    count++;
                }
            }
            previousTitle = title;
        });
        // window.addEventListener(
        //     'resize',
        //     () => {
        //         count=0;
        //         allTitles.forEach((title) => {
        //             title.nextElementSibling.classList.remove('hidden')
        //         })
        //         allTitles.forEach((title, i) => {
        //             if (i > 0 && title.offsetTop !== previousTitle.offsetTop) {
        //                 title.previousElementSibling.classList.add('hidden');
        //             }

        //             previousTitle = title;
        //         });
        //     },
        //     true
        // );
    },
};
